export enum Features {
    SMARTLING_TRANSLATE = "smartling_translate",
    DEVELOPER_SANDBOX = "developer_sandbox"
}
